import { useState } from "react";
import { Check, Phone } from "lucide-react";
import { Reveal } from "../components/shared";
import { SiteLayout, PageHero } from "../components/site";
import { EnquiryForm, TOPICS } from "../components/enquiry";
import { CONTACT } from "../content";

const Sent = () => (
  <div className="text-center py-10" data-testid="enquiry-page-success">
    <span className="mx-auto w-14 h-14 rounded-full bg-[#F6F2E9] grid place-items-center"><Check className="w-6 h-6 text-[#3F4A3C]" /></span>
    <h2 className="mt-6 font-newsreader text-3xl text-[#3F4A3C]">Thank you, we've got it.</h2>
    <p className="mt-3 font-jakarta text-sm text-[#4A4F45]">Our team will be in touch soon. If it's urgent, please call {CONTACT.phone}.</p>
  </div>
);

export default function Enquire() {
  const [sent, setSent] = useState(false);
  const topic = TOPICS.includes(new URLSearchParams(window.location.search).get("topic")) ? new URLSearchParams(window.location.search).get("topic") : TOPICS[0];
  return (
    <SiteLayout testid="enquire-page">
      <PageHero eyebrow="Send an enquiry" lines={["Tell us a little,", "we'll take it from there."]} sub="Send a few lines and our team will get back to you." />
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-24 grid lg:grid-cols-12 gap-8">
        <Reveal className="lg:col-span-8 rounded-[28px] bg-[#E3E9E4] p-6 sm:p-10">
          {sent ? <Sent /> : <EnquiryForm topic={topic} onSent={() => setSent(true)} />}
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4 rounded-[28px] bg-[#F9F6EF] border border-[#3F4A3C]/10 p-7 sm:p-8 self-start">
          <p className="font-newsreader text-2xl text-[#3F4A3C]">Prefer to talk?</p>
          <p className="mt-3 font-jakarta text-sm text-[#4A4F45]">Our friendly admin team can help with questions, referrals and next steps.</p>
          <a href={CONTACT.phoneHref} data-testid="enquire-call" className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#3F4A3C] px-6 py-3.5 font-jakarta text-sm text-[#F6F2E9] hover:bg-[#5F7C8A] transition-colors"><Phone className="w-4 h-4" /> Give us a call</a>
        </Reveal>
      </section>
    </SiteLayout>
  );
}
